import learningPage from "@/views/setting/learningPage";
import lawModal from "@/views/setting/lawModal";
import coinCost from "@/views/setting/coinCost";

const routes = [
 {
    path: '/setting/learningPage',
    name: 'learningPage',
    component: learningPage,
    meta:{requiredAuth:true}
  },
  {
    path: '/setting/lawModal',
    name: 'lawModal',
    component: lawModal,
    meta:{requiredAuth:true}
  },
  {
    path: '/setting/coinCost',
    name: 'coinCost',
    component: coinCost,
    meta:{requiredAuth:true}
  },
]

export default routes